import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';

import { Approval } from '@interfaces';

@Component({
    selector: 'tab-approvals-equipments-attachments',
    templateUrl: './tab-approvals-equipments-attachments.component.html'
})
export class TabApprovalsEquipmentsAttachmentsComponent implements OnInit{
    constructor(
        @Inject(MAT_DIALOG_DATA) public approval: Approval
    ) {}

    ngOnInit(): void {
        this.approval.equipment.attachments = _.filter(this.approval.equipment.attachments, (attachment) => attachment.archived === false);
    }
}
